import React from 'react';
import './FormSubtitle.css';

/**
 * FormSubtitle Component
 * Secondary form heading (h3/h4)
 * 
 * @param {string} text - Subtitle text
 * @param {number} level - Heading level: 3 | 4 (default: 3)
 * @param {string} className - Additional CSS classes
 */
const FormSubtitle = ({
  text,
  level = 3,
  className = ''
}) => {
  const HeadingTag = level === 3 ? 'h3' : 'h4';
  const levelClass = `form-subtitle-level-${level}`;

  return (
    <HeadingTag className={`form-subtitle ${levelClass} ${className}`.trim()}>
      {text}
    </HeadingTag>
  );
};

export default FormSubtitle;










